import React from 'react';
import styled from 'styled-components';
import { IMediaGalleryItem } from '@hotelplan/core.serving.bs-rsv-gallery';

interface ISlideInfoProps<T extends IMediaGalleryItem> {
  item?: T | undefined;
  slide?: number;
  count?: number;
  className?: string;
  isHideBackground?: boolean;
}

const ProductSlideCount = styled.div(
  ({ theme: { media, fontSizes, space } }) => ({
    display: 'flex',
    position: 'relative',
    left: 0,
    top: '-39px',
    fontSize: fontSizes[1],
    color: 'white',
    '&.overlay': {
      width: '80%',
      left: 'calc(15% / 2)',
      top: space[4],
      '~ .slide-info': {
        background: 'rgba(0, 0, 0, 0.5)',
        [media.mobile]: {
          padding: space[3],
        },
      },
      [media.mobile]: {
        top: '20px',
        left: space[3],
      },
    },
  })
);

function FdrGeoProductGallerySlideCount<T extends IMediaGalleryItem>(
  props: ISlideInfoProps<T>
): React.ReactElement | null {
  const { item, slide, count } = props;

  if (!item) {
    return null;
  }

  return (
    <>
      {slide && count ? (
        <ProductSlideCount>
          {slide} | {count}
        </ProductSlideCount>
      ) : null}
    </>
  );
}

export default FdrGeoProductGallerySlideCount;
